<p class="text-sm pb-1" [class.font-bold]="bold()">
  {{ label() }}
</p>

<mat-form-field
  appearance="outline"
  floatLabel="always"
  class="w-full textarea-control-field"
  [ngClass]="{ 'opacity-70': disabled() }"
>
  @if (icon()) {
    <mat-icon
      matPrefix
      class="h-5 w-5 text-xl leading-5 text-gray-500"
    >
      {{ icon() }}
    </mat-icon>
  }

  <textarea
    matInput
    [placeholder]="placeholder()"
    [minLength]="minlength()"
    [maxLength]="maxlength()"
    [rows]="rows()"
    [formControl]="ispFormControl()"
    (blur)="handleBlur()"
    [readonly]="disabled()"
    [ngClass]="{ 'cursor-default': disabled() }"
    (input)="handleModelChange($any($event.target).value)"
  ></textarea>

  @if (countChars() && maxlength()) {
    <span
      matTextSuffix
      class="text-gray-500 customSuffixPosition"
    >
      {{ ispFormControl().value?.length || 0 }}/{{ maxlength() }}
    </span>
  }

  @if (hint()) {
    <mat-hint class="text-xs">
      {{ hint() }}
    </mat-hint>
  }
</mat-form-field>

<!-- Required error -->
@if (
  (ispFormControl().touched || ispFormControl().dirty) &&
  ispFormControl().errors?.['required']
) {
  <mat-error class="text-sm -mt-5">
    {{ errorMessage() || 'Field is required' }}
  </mat-error>
}

<!-- Special character error -->
@if (onlyAllowedCharactersPresent) {
  <mat-error
    class="text-sm {{ specialCharacterValidationErrorClass() }}"
  >
    Only special characters like {{ allowedCharacters }} are allowed.
  </mat-error>
}